var v1="<div gnp-stroke-analysis=\"\" stroke-data=\"staCtrl.strokeData\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/stroke-analysis/stroke-analysis.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/analysis/stroke-analysis/stroke-analysis.jade
// module id = 461
// module chunks = 0